import * as Yup from 'yup';

const schema = Yup.object().shape({
  acronym: Yup.string().required(' '),

  stageName: Yup.string().required(' '),
});

export default schema;
